import * as React from 'react';
import TooltipService from '../../services/TooltipService';
import styles from './Tooltip.module.css';
import classnames from 'classnames';
import { ShowOnRoot } from '~/context/ShowOnRoot';

class TooltipProps {
  tooltip: TooltipService;
  getTooltipContent: (x: any) => any;
}

const Tooltip: React.FC<TooltipProps> = ({ tooltip, getTooltipContent }) => {
  const [show, setShow] = React.useState(false);
  const [xValue, setX] = React.useState(null);
  const timeout = React.useRef<NodeJS.Timeout>(undefined);
  const [position, setPosition] = React.useState<any>(null);
  React.useEffect(() => {
    tooltip.onTooltipOpen = (x: number, y: number, xValue) => {
      setPosition({ left: x, top: y });
      setX(xValue);
      clearTimeout(timeout.current);
      setShow(true);
    };
    tooltip.onTooltipClose = () => {
      timeout.current = setTimeout(() => {
        setShow(false);
        timeout.current = setTimeout(() => {
          setPosition(null);
        }, 300);
      }, 500);
    };
  }, []);
  return (
    <ShowOnRoot>
      <div style={position && { ...position }} className={classnames(styles.Tooltip, { [styles.Show]: show })}>
        {xValue && getTooltipContent(xValue)}
      </div>
    </ShowOnRoot>
  );
};

export default Tooltip;
